export default {
      id: "i-triangle-grey-usage",
      viewBox: "0 0 7 7",
      url: __webpack_public_path__ + "img/sprite.svg#i-triangle-grey",
      toString: function () {
        return this.url;
      }
    }